// Product catalogue for Thermo Edge Insulation
export const PRODUCTS = [
    {
        slug: "air-bubble-insulation",
        index: "01",
        name: "Air Bubble Insulation",
        short: "Reflective double-layer bubble foil for radiant heat control.",
        tagline: "The quiet workhorse of thermal protection.",
        hero: "https://images.unsplash.com/photo-1705254772179-991469a47e19?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
        thumb: "https://images.unsplash.com/photo-1784739893954-b64adc267d62?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        overview:
            "Air Bubble Insulation is a multi-layer thermal barrier that couples reflective aluminium foil with a polyethylene air-bubble core. It blocks up to 97% of radiant heat, cuts condensation, and installs cleanly on roofs, walls and ductwork.",
        features: [
            "Reflective foil on both faces (up to 97% radiant heat rejection)",
            "Sealed polyethylene bubble core",
            "Anti-condensation & vapour barrier",
            "Lightweight — under 400 gsm",
            "Non-toxic, dust-free, safe to handle",
            "Available in rolls up to 40m",
        ],
        benefits: [
            "Reduces indoor temperature by 8–15°C",
            "Lowers HVAC energy bills up to 40%",
            "Improves worker comfort in warehouses & sheds",
            "Fast, clean install with foil tape",
        ],
        specs: [
            ["Thickness", "4–10 mm"],
            ["Roll Width", "1.2 m / 1.5 m"],
            ["Roll Length", "40 m (standard)"],
            ["Reflectivity", "≥ 95%"],
            ["Emissivity", "≤ 0.05"],
            ["Fire Rating", "Class B (self-extinguishing)"],
            ["Temperature Range", "-40°C to +90°C"],
        ],
        applications: [
            "Warehouse & godown roofs",
            "Factory sheds & industrial ceilings",
            "Poultry farm insulation",
            "Cold storage walls",
            "HVAC duct wrapping",
        ],
        installation:
            "Fix over purlins/rafters, overlap edges by 50 mm and seal with Thermo Edge aluminium foil tape. Maintain a 25 mm air gap above the insulation for maximum reflective performance.",
    },
    {
        slug: "xlpe-insulation",
        index: "02",
        name: "XLPE Insulation",
        short: "Closed-cell cross-linked polyethylene for thermal & acoustic control.",
        tagline: "Dense, quiet, and built to last decades.",
        hero: "https://images.unsplash.com/photo-1771970472779-6452fbce94d6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
        thumb: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        overview:
            "XLPE (cross-linked polyethylene) is a closed-cell foam laminated with aluminium foil. It delivers premium thermal insulation, acoustic damping and dimensional stability — the choice for high-spec industrial and commercial roofing.",
        features: [
            "Closed-cell structure (near-zero water absorption)",
            "Aluminium foil facing for radiant reflection",
            "Excellent acoustic insulation (up to 27 dB reduction)",
            "Long service life — 25+ years",
            "CFC / HCFC free",
            "Available 4 mm to 25 mm thickness",
        ],
        benefits: [
            "K-value as low as 0.032 W/mK",
            "Superior noise damping in metal roofs",
            "Rot & pest resistant",
            "Dimensional stability under thermal cycling",
        ],
        specs: [
            ["Density", "30–40 kg/m³"],
            ["Thermal Conductivity", "0.032 W/mK"],
            ["Thickness", "4 / 6 / 8 / 10 / 15 / 20 / 25 mm"],
            ["Water Absorption", "< 1%"],
            ["Fire Rating", "Class B1"],
            ["Operating Temp", "-80°C to +100°C"],
            ["Acoustic Reduction", "up to 27 dB"],
        ],
        applications: [
            "PEB & metal roof underlayer",
            "Cold rooms & refrigerated warehouses",
            "Automotive & marine insulation",
            "HVAC ducting",
            "Commercial ceilings",
        ],
        installation:
            "Lay XLPE foil-face down over the roof purlins before sheeting. Overlap 50 mm, tape all joints with foil tape, and ensure a continuous vapour barrier at eaves and ridges.",
    },
    {
        slug: "aluminium-foil-tape",
        index: "03",
        name: "Aluminium Foil Tape",
        short: "High-tack foil tape for sealing insulation joints & duct seams.",
        tagline: "The seal that holds the system together.",
        hero: "https://images.unsplash.com/photo-1784739893954-b64adc267d62?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
        thumb: "https://images.unsplash.com/photo-1772300704502-410f0fbd43bb?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        overview:
            "Thermo Edge Aluminium Foil Tape is a pure-aluminium foil coated with an aggressive acrylic pressure-sensitive adhesive. It creates air-tight, vapour-tight joints on insulation, HVAC ducts and refrigeration lines.",
        features: [
            "Pure aluminium foil (30–50 microns)",
            "Solvent-based acrylic adhesive",
            "Silicone-coated release liner",
            "UV, moisture & temperature resistant",
            "Rolls in 48 mm / 72 mm widths",
        ],
        benefits: [
            "Instant, permanent seal",
            "Excellent radiant heat reflection at joints",
            "Works from -30°C to +120°C",
            "Clean, professional finish",
        ],
        specs: [
            ["Foil Thickness", "30 / 40 / 50 microns"],
            ["Total Thickness", "60 / 75 microns"],
            ["Adhesive", "Acrylic PSA"],
            ["Peel Strength", "≥ 12 N/25 mm"],
            ["Tensile Strength", "≥ 50 N/25 mm"],
            ["Width Options", "48 mm / 72 mm / 100 mm"],
            ["Roll Length", "40 m / 45 m"],
        ],
        applications: [
            "Sealing bubble & XLPE insulation joints",
            "HVAC duct seams",
            "Refrigeration line sealing",
            "Vapour barrier joints",
            "General industrial repair",
        ],
        installation:
            "Ensure the surface is clean, dry and dust-free. Peel liner, apply tape with firm pressure using a squeegee to eliminate air pockets. Overlap seams by minimum 25 mm.",
    },
    {
        slug: "air-bubble-packaging-roll",
        index: "04",
        name: "Air Bubble Packaging Roll",
        short: "Cushioning bubble film for logistics, fragile & industrial packing.",
        tagline: "Protection that survives every handoff.",
        hero: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
        thumb: "https://images.unsplash.com/photo-1705254772179-991469a47e19?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        overview:
            "Heavy-duty air bubble film with a strong LDPE outer layer and uniform bubble matrix. Engineered to absorb impact through the supply chain — from warehouse pick-and-pack to last-mile delivery.",
        features: [
            "Uniform bubble grid (10 mm / 25 mm variants)",
            "LDPE film with high puncture resistance",
            "Anti-static option available",
            "100% recyclable",
            "Rolls up to 100 m",
        ],
        benefits: [
            "Absorbs shock and vibration",
            "Reduces transit damage claims",
            "Lightweight — no added freight cost",
            "Cuts cleanly with scissors or blade",
        ],
        specs: [
            ["Bubble Size", "10 mm / 25 mm"],
            ["Film Thickness", "40 / 60 / 80 GSM"],
            ["Roll Width", "1 m / 1.2 m / 1.5 m"],
            ["Roll Length", "50 m / 100 m"],
            ["Colour", "Transparent (standard) / Pink (anti-static)"],
            ["Recyclability", "LDPE-4"],
        ],
        applications: [
            "E-commerce fulfilment",
            "Fragile goods packaging",
            "Furniture & appliance wrapping",
            "Component protection for logistics",
            "Cold-chain outer wrap",
        ],
        installation:
            "Roll out required length, cut to size. Wrap item with bubble-side inward for maximum cushioning. Seal with tape or heat-seal for high-volume operations.",
    },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
